import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=25cc6dc6&scoped=true"
import script from "./Gift.vue?vue&type=script&lang=js"
export * from "./Gift.vue?vue&type=script&lang=js"
import style0 from "./Gift.vue?vue&type=style&index=0&id=25cc6dc6&prod&lang=css&scoped=true"
import style1 from "./Gift.vue?vue&type=style&index=1&id=25cc6dc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cc6dc6",
  null
  
)

export default component.exports